import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { UrlConstants } from "../utils/CommonUtils/constants";

const firebaseConfig = {
  apiKey: UrlConstants.FIREBASE_API_KEY,
  authDomain: UrlConstants.FIREBASE_AUTH_DOMAIN,
  projectId: UrlConstants.FIREBASE_PROJECT_ID,
  storageBucket: UrlConstants.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: UrlConstants.FIREBASE_MESSAGING_SENDER_ID,
  appId: UrlConstants.FIREBASE_APP_ID,
  measurementId: UrlConstants.FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };
